import React from 'react';

import * as S from './PanesLimitModal.styles';

export interface PanesLimitModalLocales {
  title: string;
  message: string;
  closeButton: string;
}

interface PanesLimitModalProps {
  onClose: () => void;
  locales: PanesLimitModalLocales;
}

export const PanesLimitModal = ({
  onClose,
  locales,
}: PanesLimitModalProps) => {
  return (
    <S.StyledModal
      data-testid="panes-limit-modal"
      isOpen
      title={locales.title}
      onClose={onClose}
      cancelBtnProps={{
        label: locales.closeButton,
        onClick: onClose,
      }}
    >
      <S.Text>{locales.message}</S.Text>
    </S.StyledModal>
  );
};
